import { InputText } from 'primereact/inputtext';
import { AutoComplete } from 'primereact/autocomplete';
import { agregarProducto } from '../../../service/AffariService.js';
import { useGlobalContext } from "../../../Config";
import { Checkbox } from 'primereact/checkbox';

const BarraBusquedaCotizacion = ({
    idCotizacion,
    onAdded,
    onNotify,
    codigoBusqueda,
    setCodigoBusqueda,
    descripcionBusqueda,
    setDescripcionBusqueda,
    productosBusqueda,
    searchProductosBusqueda
}) => {
    const { isDinar, isSack } = useGlobalContext();
    const handleAddByCodigo = async () => {
        const codigo = (codigoBusqueda || '').trim();
        if (!codigo) return;
        try {
            await agregarProducto(idCotizacion, codigo);
            //if (onNotify) onNotify('success', 'Producto agregado', `Código ${codigo}`);
            if (onAdded) onAdded();
            setCodigoBusqueda('');
        } catch (error) {
            if (onNotify) onNotify('error', 'Error agregando producto', 'El producto ya fue agregado o no existe.' || error.message);
        }
    };

    const handleSelect = async (e) => {
        const item = e.value;
        const codigo = item && item.codigo;
        if (!codigo) return;
        try {
            await agregarProducto(idCotizacion, codigo);
            //if (onNotify) onNotify('success', 'Producto agregado', `Código ${codigo}`);
            if (onAdded) onAdded();
            setDescripcionBusqueda('');
        } catch (error) {
            if (onNotify) onNotify('error', 'Error agregando producto', 'El producto ya fue agregado o no existe.' || error.message);
        }
    };

    return (
        <>  
            {isDinar && (
                <>
                    <div className="flex align-items-center gap-2 md:mr-3 ">
                        <Checkbox
                        />
                        <label htmlFor="codigoBusqueda" className="text-sm font-medium w-6rem md:w-auto">Marcar todas como caja completa</label>
                    </div>
                </>
            )}
            {isSack && (
                <>
                    <div className="flex align-items-center gap-2 md:mr-3 ">
                        <label htmlFor="codigoBusqueda" className="text-sm font-medium w-6rem md:w-auto">Código</label>
                        <InputText
                            id="codigoBusqueda"
                            value={codigoBusqueda}
                            onChange={(e) => setCodigoBusqueda(e.target.value)}
                            className="p-inputtext-sm flex-1 md:w-8rem md:flex-none"
                            onKeyDown={(e) => { if (e.key === 'Enter') handleAddByCodigo(); }}
                            placeholder="Ingrese código"
                        />
                    </div>
                    <div className="flex align-items-center gap-2 md:flex-1">
                        <label htmlFor="descripcionBusqueda" className="text-sm font-medium w-6rem md:w-auto">Descripción</label>
                        <AutoComplete
                            placeholder="Ingrese descripción"
                            id="descripcionBusqueda"
                            value={descripcionBusqueda}
                            suggestions={productosBusqueda}
                            completeMethod={searchProductosBusqueda}
                            field="descripcion"
                            onChange={(e) => setDescripcionBusqueda(e.value)}
                            className="flex-1 md:w-25rem md:flex-none"
                            inputClassName="p-inputtext-sm w-full"
                            dropdown
                            onSelect={handleSelect}
                            onKeyDown={(e) => { if (e.key === 'Enter') { const first = productosBusqueda && productosBusqueda[0]; if (first && first.codigo) handleSelect({ value: first }); } }}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default BarraBusquedaCotizacion;